// extracted by mini-css-extract-plugin
module.exports = {"noData":"no-data_noData__X2Esg"};